import React from "react"
import { withRouter } from "react-router-dom"
import queryString from "query-string"
import { useSelector } from "react-redux"
import { profileSteps } from "../../Redux/Reducers/Application/profileMetadata"
import { spouseProfileSteps } from "../../Redux/Reducers/SpouseApplication/spouseProfileMetadata"
import { NonDodIcProfileSteps } from "../../Redux/Reducers/NonDodIcApplication/NonDodIcProfileMetadata"
import { AlliedForcesProfileSteps } from "../../Redux/Reducers/AlliedForcesApplication/AlliedForcesProfileMetadata"
import UserFieldEditorHeader from "../UserFieldEditorHeader/UserFieldEditorHeader"

const ProfileHeader = (props) => {
  
  const reduxStateData = useSelector((state) => {
    try {
      const pageTitle = queryString.parse(props.history.location.search).title
      
      // Find step in all possible metadata
      const stepOd = profileSteps.find((elem) => elem.stepId === pageTitle)
      const stepSpouse = spouseProfileSteps.find((elem) => elem.stepId === pageTitle)
      const stepNonDodIc = NonDodIcProfileSteps.find((elem) => elem.stepId === pageTitle)
      const stepAlliedForces = AlliedForcesProfileSteps.find((elem) => elem.stepId === pageTitle)
      const stepData = stepOd || stepSpouse || stepNonDodIc || stepAlliedForces
      
      if (!stepData) {
        return null
      }
      
      const { stepId } = stepData
      if (!stepId) {
        return null
      }
    
      // Check is_spouse from multiple state locations (parity with commit-api-back logic)
      const isSpouse = state.user?.user?.is_spouse 
        ?? state.application?.application?.is_spouse 
        ?? state.nonDodIcApplication?.application?.is_spouse
        ?? state.alliedForcesApplication?.application?.is_spouse
        ?? 0
      
      // Determine which profileMetadata to use based on is_spouse value
      // 0=veteran, 1=spouse, 2=non-dod-ic, 3=allied-forces
      let profileMetadata = []
      
      if (isSpouse === 1) {
        // Spouse users
        profileMetadata = state.spouseApplication?.spouseProfileMetadata || []
      } else if (isSpouse === 2) {
        // Non-DOD IC users
        profileMetadata = state.nonDodIcApplication?.profileMetadata || []
      } else if (isSpouse === 3) {
        // Allied Forces users
        profileMetadata = state.alliedForcesApplication?.profileMetadata || []
      } else {
        // Veterans (isSpouse === 0)
        profileMetadata = state.application?.profileMetadata || []
      }
      
      if (!profileMetadata || profileMetadata.length === 0) {
        return null
      }
      
      const item = profileMetadata.find((item) =>
        item && item.steps && Array.isArray(item.steps) && item.steps.some((step) => step && step.stepId === stepId)
      )
      
      if (!item || !item.steps) {
        return null
      }

      const step = item.steps.find((step) => step && step.stepId === stepId)
      
      if (!step) {
        return null
      }

      return {
        title: step.title,
        sectionTitle: item.title,
        stepsLength: item.steps.length,
        currentStepIndex: item.steps.findIndex((step) => step.stepId === stepId),
        description: step.body
      }
    } catch (error) {
      return null
    }
  })

  if (!reduxStateData) return null; // Handle the case where reduxStateData is not available

  return (
    <UserFieldEditorHeader
      sectionTitle={reduxStateData.sectionTitle}
      title={reduxStateData.title}
      currentStepIndex={reduxStateData.currentStepIndex}
      stepsLength={reduxStateData.stepsLength}
      description={reduxStateData.description}
    />
  )
}


export default withRouter(ProfileHeader)
